<template>
    <el-drawer
        :title="label"
        :visible.sync="showBox"
        direction="rtl"
        size="300px"
        :append-to-body="true"
        :before-close="close">
        <div class="panel form">
            <file-preview v-for="(item, i) in resources" :key="i" :allow-preview="true" :allow-download="true"
                width="200" height="120" :url="item.url" @play="$emit('play', item.url2 != null ? item.url2 : item.url)"></file-preview>
        </div>
        <span  class="fx fx-center">
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>


    export default {
        props: [
            "label",
            "resources",
            "showBox",
        ],
        data() {
            return {}
        },


        methods: {
            close() {
                this.$emit("close");
            },

        },


    }
</script>
